import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from "prop-types"
import i18n from 'i18n/index.js'
import ExcursionImage from "components/products/ExcursionImage";
import { money, from_price } from "components/utils/Money.jsx";
import { duration_time_by_duration_type } from "components/utils/Duration.jsx";
import { buildLocalePath } from "components/utils/Locale";

function ProductSlim(props) {

    const createSelectItemDataLayer = () => {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': "select_item",
            'ecommerce': {
                'item_list_id': "products_list",
                'item_list_name': "Products List",
                'items': [
                    {
                        'item_id': props.product.id,
                        'item_name': props.product.title,
                        'price': from_price(props.product),
                        'item_brand': (props.product.agency ? props.product.agency?.name : "Outdoor Index"),
                        'item_category': (props.product.zone && props.product.zone.name || ""),
                        'item_variant': 'Excursion',
                        'affiliation': 'Outdoor index',
                        'quantity': '1'
                    }
                ]
            }
        });
    };

    return (
        <>
            <div className={"posts-recommended flex" + (props.product && props.product.zone && props.product.zone.name.toLowerCase().split(" ").join("-") || "")}>

                <div className="free">
                    {props.product.private_check &&
                        <span className="oi-flex oi-flex-row oi-items-start oi-justify-start oi-text-left oi-w-full">
                            <span className="tooltip">
                                <span className='mdl-chip brand-label'>
                                    <span className='mdl-chip__text'>
                                        {i18n.t("ondemand.label")}
                                    </span>
                                </span>
                            </span>
                        </span>
                    }

                    <ExcursionImage
                        key={"excursion-image-" + props.product.id}
                        product={props.product}
                        image_format={props.image_format}
                        skeleton_height={(props.skeleton_height ? props.skeleton_height : 352)}
                        createSelectItemDataLayer={createSelectItemDataLayer}
                    />
                </div>

                <div className="info-slide oi-flex oi-flex-column">
                    {
                        props.product.zone &&
                        <p className="zone h7">{props.product.zone.name}</p>
                    }

                    <h4><a href={buildLocalePath("products/" + (props.product.slug != null ? props.product.slug : props.product.id))} title="View Details" onClick={() => createSelectItemDataLayer()} target="_blank">{props.product.title}</a></h4>

                    {/* Cambiar segundo parametro a false si no quieres mostra duration_type */}
                    <p className="price h5">
                        {i18n.t('from')} {money(props.product)} | {duration_time_by_duration_type(props.product, false)}
                    </p>
                    {
                        props.extra_info &&
                        <div className="landing-extra-info">
                            <div className="landing-product-container">
                                <a className="landing-product-view h4" href={buildLocalePath("products/" + (props.product.slug != null ? props.product.slug : props.product.id))} title="View Details" target="_blank">{i18n.t('active_admin.landing.more_info')}</a>
                            </div>
                        </div>

                    }
                </div>
            </div>
        </>
    );
}

export default ProductSlim
